import React from "react";

import t from "../../../Common/utils/translation/translator";

import { FaSort } from "react-icons/fa";

const AxisSelectionTableHeader = ({
  title,
  colNumber,
  isSort,
  hasUnitHeader,
  subHeaders,
  unit,
  mechanics,
  productTableHeaders,
  technicalFeaturesTableHeaders,
  performanceOverviewTableHeaders,
  getGuidingSystemTableHeaders,
  ...props
}) => {
  const TableHeaders = [
    { name: t("cartesian.ui.axis_selection.product"), sort: true },
    ...productTableHeaders,
    ...technicalFeaturesTableHeaders,
    ...performanceOverviewTableHeaders,
    ...getGuidingSystemTableHeaders(mechanics.quantityCarriages),
    { name: t("cartesian.ui.axis_selection.select"), sort: false }
  ];

  return (
    <th
      className={`AxisSelectionTableHeader border-[1px] border-solid border-x-[0.5px] border-gray-200 bg-gray-100 p-0 ${
        colNumber === 0 ? "sticky left-0 z-10" : ""
      } ${colNumber === TableHeaders.length - 1 ? "sticky right-0 z-10" : ""}`}
      {...props}
    >
      <div className="flex flex-col justify-between h-full min-h-[80px] divide-y divide-gray-300">
        <div className="flex items-center space-x-2 text-xs font-semibold py-1 px-4 flex-grow">
          <span className="whitespace-nowrap m-auto">{title}</span>
          {isSort && <FaSort className="cursor-pointer text-gray-500 text-base" />}
        </div>
        {subHeaders && subHeaders.length > 0 ? (
          <>
            <div className="flex divide-x divide-gray-300">
              {subHeaders.map((subHeader, index) => (
                <div key={index} className="flex-1 px-4">
                  <span className="text-xs font-normal py-1 whitespace-nowrap">{subHeader.name}</span>
                </div>
              ))}
            </div>
            <div className="flex items-center space-x-2 font-normal text-xs py-1 bg-gray-300">
              {subHeaders.map((subHeader, index) => (
                <div key={`unit-${index}`} className="flex-1 px-4">
                  <span className="text-xs font-normal py-1 whitespace-nowrap">{subHeader.unit || "-"}</span>
                </div>
              ))}
            </div>
          </>
        ) : (
          hasUnitHeader && (
            <div className="flex items-center space-x-2 font-normal text-xs py-1 px-4 bg-gray-300 border-b border-gray-200">
              <span className="whitespace-nowrap">{unit || "-"}</span>
            </div>
          )
        )}
      </div>
    </th>
  );
};

export default AxisSelectionTableHeader;
